export default __webpack_public_path__ + "static/media/materialorg.1f06ff31.png";